import { m8API } from 'services/production/m8';
import { PartnerPasswordFormSubmitService } from 'types/services';

export const submitPartnerPasswordForm: PartnerPasswordFormSubmitService = async (
  params
) => {
  await m8API.partner.setPartnerPassword({ password: params.password });
};
